import { useState } from "react";
import { Loader2, X } from "lucide-react";
import { http, API, errMsg, setToken } from "../../lib/api";
import { Wordmark } from "../landing/Logo";

const input = "w-full rounded-xl border border-cyan-400/20 bg-[#050911] px-4 py-3 text-sm text-white outline-none focus:border-cyan-400/70";

export const Login = ({ onDone }) => {
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!API) return setErr("Backend not configured.");
    setLoading(true); setErr("");
    try {
      const { data } = await http.post("/auth/login", { password });
      setToken(data?.token);
      onDone();
    } catch (e2) { setErr(errMsg(e2)); } finally { setLoading(false); }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#050911] px-5 text-white grid-bg">
      <form onSubmit={submit} data-testid="admin-login-form" className="relative w-full max-w-sm rounded-3xl border border-cyan-400/20 bg-[#0A101D]/90 p-8 backdrop-blur-xl">
        <a href="/" data-testid="admin-login-close-button" aria-label="Close and go back to site"
          className="absolute right-4 top-4 grid h-9 w-9 place-items-center rounded-full border border-cyan-400/20 text-slate-300 hover:border-cyan-400 hover:text-[#00E5FF] transition-colors">
          <X className="h-4 w-4" />
        </a>
        <Wordmark />
        <p className="mt-6 font-mono text-xs uppercase tracking-[0.3em] text-[#00E5FF]">Admin access</p>
        <div className="mt-6 space-y-3">
          <input type="password" required placeholder="Admin code" autoFocus value={password} onChange={(e) => setPassword(e.target.value)} className={input} data-testid="admin-login-passcode-input" />
        </div>
        {err && <p className="mt-3 text-sm text-red-400" data-testid="admin-login-error">{err}</p>}
        <button type="submit" disabled={loading} data-testid="admin-login-submit-button"
          className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-[#00E5FF] py-3 font-mono text-xs font-bold uppercase tracking-[0.15em] text-[#050911] hover:bg-white transition-colors">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Enter
        </button>
      </form>
    </div>
  );
};
